import i18next from "i18next";
import {
  AttributeType,
  REGEXP_DECIMAL,
  REGEXP_INTEGER,
  REGEXP_PERCENTAGE,
  REGEXP_SEMICOLON,
} from "./Constants";
import moment from "moment";

export const AttributeListTypes = [
  AttributeType.LIST_MULTIPLE,
  AttributeType.LIST_UNIQUE
];

export const hasAttributeListItems = (type) =>
  type === AttributeType.LIST_MULTIPLE || type === AttributeType.LIST_UNIQUE;

export const hasAttributeListItemsToShow = (type, bondType) =>
  type === AttributeType.LIST_MULTIPLE || type === AttributeType.LIST_UNIQUE || (type === AttributeType.BOOLEAN && bondType !== "dossier");

export const hasAttributeListItemsToShowForCategory = (category) => {
  return AttributeListTypes.some(type => category?.type?.includes(type));
}

export const AttributeCategories = [
  {
    key: "INDUED",
    value: "indued",
    bondType: "thirdparty",
    type: [AttributeType.LIST_MULTIPLE]
  }
];

export const attributeMaxLengthErrorText = (input, length) =>
  i18next.t("attributes.errors.maxLength", {
    input: i18next.t(input),
    length,
  });

export const getAttributeMaxLengthRule = (input, maxlength) => {
  return {
    value: maxlength,
    message: attributeMaxLengthErrorText(input, maxlength),
  };
};

// Attribute validation for types : String, Integer, Decimal and Percentage.
export const validateAttributeInputForType = (type, value) => {
  switch (type) {
    case AttributeType.INTEGER:
      return value && !value.match(REGEXP_INTEGER)
        ? i18next.t("attributes.errors.integer")
        : null;
    case AttributeType.DECIMAL:
      return value && !value.match(REGEXP_DECIMAL)
        ? i18next.t("attributes.errors.decimal")
        : null;
    case AttributeType.PERCENTAGE:
      return value && !value.match(REGEXP_PERCENTAGE)
        ? i18next.t("attributes.errors.percentage")
        : null;
    case AttributeType.STRING:
      return value && value.match(REGEXP_SEMICOLON)
        ? i18next.t("attributes.errors.nosemiclon")
        : null;
    default:
      return null;
  }
};

export const formatAttributeValues = (attributeValue) => {
  let values = attributeValue?.values;
  // Format for empty values
  if (!values || values.length === 0) {
    // Return null for number filter
    if ([AttributeType.DECIMAL, AttributeType.INTEGER, AttributeType.PERCENTAGE].includes(attributeValue?.type)) {
      return null
    }
    return i18next.t("notSpecified");
  }

  // Format boolean values
  if (attributeValue?.type === AttributeType.BOOLEAN) {
    values = values.map(x => x === "true" ? i18next.t("yes") : i18next.t("no"));
  }
  // Format percentage for filter purposes
  if (attributeValue?.type === AttributeType.PERCENTAGE) {
    values = values.map(x => x.slice(0, -1).replace(",", "."));
  }
  // Format decimals for filter purposes
  if (attributeValue?.type === AttributeType.DECIMAL) {
    values = values.map(x => x.replace(",", "."));
  }
  return values.join(", ");
}

// Sort Attribute Values of type Multiple List according to field order
export const sortAttributeMultipleListValue = (attributeValuesStr, field, sortModel) => {
  let attributeValuesArr = attributeValuesStr?.split(", ");

  if(field === sortModel?.[0]?.field && sortModel?.[0]?.sort === 'desc') {
    attributeValuesArr = attributeValuesArr?.sort((a,b) => b?.localeCompare(a))
  } else {
    attributeValuesArr = attributeValuesArr?.sort((a,b) => a?.localeCompare(b))
  }
  return attributeValuesArr?.join(", ");
}

/**
 * Builds an array of objects by attribute value label, each having the available values of the datagrid rows.
 * @param {*} attributes
 * @returns ex : [{label: 'Transport', type: 'list_unique', gridColumnType: 'singleSelect', values: ['car', 'bus']}]
 */
export const buildAttributesGridColumns = (attributes) => {

  return attributes?.map(attr => ({
    attributeId: attr.id,
    label: attr.label,
    type: attr.type,
    gridColumnType: getAttributeGridColumnType(attr.type),
    values: ( typeof attr.values == Array) ?  attr.values?.map(attrValue => attrValue?.value)?.sort() : []
  }))
  ?.sort((a, b) => a.label?.localeCompare(b.label));
    
}

export const getAttributeGridColumnType = (attributeColumnType) => {
  switch (attributeColumnType) {
    case "list_unique":
    case "boolean":
      return "singleSelect";
    case "integer":
    case "decimal":
    case "percentage":
      return "number";
    case "date":
      return "date";
    default:
      return "string";
  }
}

export const getAttributeValueOptions = (attributeColumn) => {
  switch (attributeColumn.type) {
    case "list_unique":
      if (!attributeColumn.values?.includes(i18next.t("notSpecified"))) {
        attributeColumn.values?.unshift(i18next.t("notSpecified"))
      }
      return attributeColumn.values?.map(value => ({ value, label: <span>{value}</span> }));
    case "boolean":
      return [i18next.t("notSpecified"), i18next.t("yes"), i18next.t("no")]?.map(value => ({ value, label: <span>{value}</span> }));
    default:
      return null;
  }
}

export const getAttributeValueDisplay = (type, value) => {
  if (value && value !== i18next.t("notSpecified")) {
    if (type === AttributeType.PERCENTAGE) {
      value += "%"
    }
    if (type === AttributeType.DATE) {
      value = moment(value).format(i18next.t("date.dateFormat"));
    }
    return value;
  }
  return i18next.t("notSpecified");
}
